import makeStyles from '@material-ui/core/styles/makeStyles';

const columns = [
    { id: 'payment', label: 'Имя'},
    { id: 'sum', label: 'Сумма'},
    { id: 'count', label: 'Количество операций'},
 ];

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        color: '#fff', 
        paddingTop: 0, 
    },
    wrap: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        height: '48px',
        lineHeight: '48px',
        fontSize: '20px',
        color: '#ffce01',
        fontWeight: 400,
        margin: 0, 
        padding: 0
    },
    ggr: {
        display: 'inline-block',
        minWidth: '80px',
        border: '1px solid',
        borderRadius: '3px',
        fontSize: '30px',
        fontWeight: 500,
        padding: '4px 20px',
        margin: '0 4px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        transition: 'box-shadow .5s linear,text-shadow .5s linear',
        color: '#00cd62',
        borderColor: '#00cd62',
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));

const getRowsCashiers = (replenishment) => {
    return replenishment.map((item, key) => {
        return {
            payment: item.payment ? item.payment : 'Неизвестно',
            sum: new Intl.NumberFormat('ru-RU').format(item.sum) + '₽',
            count: item.count,
        }
    })
}

const getRowsCashiersOut = (withdrawal) => {
    return withdrawal.map((item, key) => {
        return {
            payment: item.payment ? item.payment : 'Неизвестно',
            sum: new Intl.NumberFormat('ru-RU').format(item.sum) + '₽',
            count: item.count,
        }
    })
} 

export {
    columns,
    useStyles,
    getRowsCashiers,
    getRowsCashiersOut
}